import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface MealType {
    cityName: any;
    mealTypeName: any;
    data: MealType
    id: number;
    spiceLevelName: string;
}

interface MealTypeState {
    data: MealType[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;

export const fetchmealType = createAsyncThunk<MealType[], void, { rejectValue: string }>(
    'mealType/fetchmealType',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: MealType[] }>('/get_all_meal_type', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createmealType = createAsyncThunk<MealType, any, { rejectValue: string }>(
    'mealType/createmealType',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: MealType }>('create_meal_type', params, PORT, MASTERURL);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);


export const updatemealType = createAsyncThunk<MealType, any, { rejectValue: string }>(
    'mealType/updatemealType',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: MealType }>('update_meal_type', params, PORT, MASTERURL);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const softDeleteMealType: any = createAsyncThunk<
    number,
    number
>(
    "mealType/softDeleteMealType",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_meal_type?id=${id}`,
                {},
                PORT,
                MASTERURL
            );

            return response



        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const mealTypeSlice = createSlice({
    name: 'mealType',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as MealTypeState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchmealType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchmealType.fulfilled, (state, action: PayloadAction<MealType[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchmealType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createmealType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createmealType.fulfilled, (state, action: PayloadAction<MealType>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createmealType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updatemealType.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatemealType.fulfilled, (state, action: PayloadAction<MealType>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updatemealType.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default mealTypeSlice.reducer;